const ENDPOINT = 'smtpinput';

export default axios => ({
  /**
   * Get SMTP_INPUT list, list of all message groups
   * @param params - params to path on backend
   * @return {*}
   */
  getList(params) {
    return axios.get(`/${ENDPOINT}/list/`, {
      redirect: 'follow',
      params
    });
  },

  /**
   * Get schema
   * @return {*}
   */
  getSchema() {
    return axios.get('/schemas/smtpinput.json');
  },

  /**
   * Get messages group data.
   * @param id
   * @return {*}
   */
  getGroup(id) {
    return axios.get(`/${ENDPOINT}/message/${id}`);
  },

  /**
   * Delete group with all messages
   * @param id - group id
   * @return {*}
   */
  deleteGroup(id) {
    return axios.delete(`/${ENDPOINT}/list/${id}`);
  },

  /**
   * Delete list of groups
   * @param ids
   * @return {*}
   */
  deleteGroupsList(ids) {
    if (Array.isArray(ids)) {
      return axios.delete(`/${ENDPOINT}/list/`, {
        data: JSON.stringify(ids)
      });
    } else {
      throw new Error(`Can't delete groups, groups ids: ${ids} must be an Array`);
    }
  },

  /**
   * Delete messages from group
   * @param ids - messages ids
   * @return {*}
   */
  deleteGroupMessages(ids) {
    if (Array.isArray(ids)) {
      return axios.delete(`/${ENDPOINT}/message/`, {
        redirect: 'follow',
        data: JSON.stringify(ids)
      });
    } else {
      throw new Error(`Can't delete group messages ids: ${ids} must be an Array`);
    }
  },
});



// WEBPACK FOOTER //
// ./src/services/smtp.service.js